export default "__VITE_ASSET__D9Te5rUH__"